export default __webpack_public_path__ + "static/media/ResourceTracking.679c2f01.png";